import type { SxProps, Theme } from '@mui/material/styles';

import { signupDisabledButtonStyles, signupTypography } from '../../../pages/signup/SignupPage/SignupPage.styles';

export const signupSummaryCardStyles = {
  summaryCard: (theme: Theme): SxProps<Theme> => ({
    display: 'flex',
    minHeight: '68px',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    px: 2,
    py: 1.25,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 1,
  }),
  summaryLabel: (theme: Theme): SxProps<Theme> => ({
    color: theme.palette.grey[700],
    fontSize: signupTypography.supporting,
    lineHeight: 1.2,
  }),
  summaryValue: (): SxProps<Theme> => ({
    fontSize: signupTypography.standard,
    lineHeight: 1.35,
  }),
  summaryDetail: (theme: Theme): SxProps<Theme> => ({
    color: theme.palette.grey[700],
    fontSize: signupTypography.supporting,
    lineHeight: 1.3,
  }),
  summaryChange: (theme: Theme): SxProps<Theme> => ({
    color: theme.palette.success.dark,
    fontSize: signupTypography.supporting,
    textTransform: 'none',
    '&:hover, &:focus, &:active': {
      bgcolor: 'transparent',
    },
    '&:focus-visible': {
      outline: `3px solid ${theme.palette.success.light}`,
      outlineOffset: '2px',
    },
    '&.Mui-disabled': {
      ...signupDisabledButtonStyles,
    },
  }),
};
